const STORAGE_KEY = 'bookthing-reels-searches';
const MAX_QUERIES_PER_USER = 8;
const MAX_REELS_PER_QUERY = 60;

function readRoot() {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export function reelsCacheKey({ platform, keyword, datePosted }) {
  return JSON.stringify([platform || 'instagram', keyword?.trim() || '', datePosted || '']);
}

export function readReelsCache(userId, query) {
  if (!userId) return null;
  const entry = readRoot()[userId]?.entries?.[reelsCacheKey(query)];
  return entry && Array.isArray(entry.reels) ? entry : null;
}

export function writeReelsCache(userId, query, value) {
  if (!userId || !Array.isArray(value?.reels)) return;
  try {
    const root = readRoot();
    const current = root[userId]?.entries || {};
    const key = reelsCacheKey(query);
    const entries = {
      ...current,
      [key]: {
        reels: value.reels.slice(0, MAX_REELS_PER_QUERY),
        nextCursor: value.nextCursor || null,
        hasMore: Boolean(value.hasMore),
        cachedAt: Date.now(),
      },
    };
    const trimmed = Object.fromEntries(
      Object.entries(entries)
        .sort(([, a], [, b]) => (b.cachedAt || 0) - (a.cachedAt || 0))
        .slice(0, MAX_QUERIES_PER_USER)
    );
    root[userId] = { entries: trimmed };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(root));
  } catch {
    // Quota/security failures leave the cache session-only.
  }
}

